import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedUser = localStorage.getItem('orbx_user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
        setLoading(false);
    }, []);

    const login = (userData) => {
        setUser(userData);
        localStorage.setItem('orbx_user', JSON.stringify(userData));
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('orbx_user');
    };

    const updateUser = (newData) => {
        const updatedUser = { ...user, ...newData };
        setUser(updatedUser);
        localStorage.setItem('orbx_user', JSON.stringify(updatedUser));
    };

    const isAdmin = () => user && (user.role === 'super_admin' || user.role === 'blog_manager');
    const isSuperAdmin = () => user && user.role === 'super_admin';
    const isPartner = () => user && user.role === 'partner';

    return (
        <AuthContext.Provider value={{ user, login, logout, updateUser, loading, isAdmin, isSuperAdmin, isPartner }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
